import noScroll from "../utils/noScroll";

export default function toggleClass(element, data) {
    element.addEventListener("click", function (event) {
        const value = data.value === null || data.value === undefined ? undefined : JSON.parse(data.value);
        const targets = document.querySelectorAll(data.target);
        const noScrollValue = data.noScroll;

        console.log("stop");
        event.stopPropagation();

        targets.forEach((element) => element.classList.toggle(data.class, value));

        if (noScrollValue !== null && noScrollValue !== undefined) {
            if (noScrollValue) {
                noScroll.hideScroll();
            } else {
                noScroll.showScroll();
            }
        }
    });
}
